module.exports = __webpack_public_path__ + "img/12@3x.91a61e0d.png";